import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectOption } from '@app/interfaces/sys/dict';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-task-checkbox',
  templateUrl: './task-checkbox.component.html',
  styleUrl: './task-checkbox.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TaskCheckboxComponent),
      multi: true,
    },
  ],
})
export class TaskCheckboxComponent implements OnInit {
  @Input() clickToEdit = false; // 点击后才编辑
  @Input() required = false;
  @Input() formControlName = '';
  @Input() value: string[] = [];
  @Input() options: string[] = [];
  @Input() inactiveUsers: boolean = false;
  @Output() valueChange = new EventEmitter();
  @Output() editSuccess = new EventEmitter();
  @Output() cancelEvent = new EventEmitter();
  saveLoading = false;

  isEditing = false;
  lastValue: string[] = [];
  checkOptions: SelectOption[] = [];
  currentValue: string[] = [];

  constructor(private message: NzMessageService,
              private confirmationService: ConfirmationService) {
  }

  onChange: any = () => {
  }
  onTouch: () => void = () => null;

  ngOnInit(): void {
    this.currentValue = this.value || [];
  }

  initData(): void {
    this.currentValue = this.currentValue || [];
    this.checkOptions = this.options.map(it => {
      return {
        label: it,
        value: it,
        checked: this.currentValue.includes(it)
      };
    });
  }

  writeValue(obj: any): void {
    this.currentValue = obj || [];
    this.initData();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  updateSingleChecked(arr: SelectOption[]): void {
    this.currentValue = this.checkOptions.filter(it => it.checked).map(x => x.value) as string[];
    this.onChange(this.currentValue);
  }

  startEditing(): void {
    if (!this.clickToEdit) {
      return;
    }
    this.initData();
    this.lastValue = [...this.currentValue] as string[];
    this.isEditing = true;
  }

  handleSave(): void {
    if (this.required && (!this.currentValue || this.currentValue.length === 0)) {
      this.message.error('This field is required');
      return;
    }
    this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
        this.isEditing = false;
        this.editSuccess.emit(this.currentValue);
    }, () => { this.handleCancel(); });
  }

  handleCancel(): void {
    this.currentValue = this.lastValue;
    this.isEditing = false;
    this.cancelEvent.emit();
  }
}
